var map = {
	"./Ayus.pdf": 5757,
	"./BU.pdf": 7655,
	"./Bavat-m.pdf": 54,
	"./Bavat-n.pdf": 3121,
	"./DAtf.pdf": 5019,
	"./DI.pdf": 5105,
	"./DImat-m.pdf": 1715,
	"./DImat-n.pdf": 2812,
	"./Denu.pdf": 914,
	"./Pala.pdf": 7652,
	"./SLP1LiesAppendixB.pdf": 6368,
	"./Sreyas-m.pdf": 8427,
	"./Sreyas-n.pdf": 6628,
	"./adas-f.pdf": 7334,
	"./adas-m.pdf": 6505,
	"./adas-n.pdf": 2734,
	"./agni.pdf": 3547,
	"./appendixB1-PhonologicalFeatures.pdf": 839,
	"./appendixB2-SanskritSegments.pdf": 252,
	"./appendixB3-AdditionalPhonologicalCategories.pdf": 7595,
	"./appendixB4-SanskritAlphabeticalOrder.pdf": 8307,
	"./appendixB5-Slp1.pdf": 6273,
	"./appendixC1-ConjunctConsonants.pdf": 9524,
	"./appendixD1-ConsonantsPrepauseAllophones.pdf": 6337,
	"./appendixD2.1-VowelSandhi.pdf": 5457,
	"./appendixD2.2-ConsonantSandhi.pdf": 8482,
	"./appendixD2.2.1-FinalStopSandhi.pdf": 8398,
	"./appendixD2.2.2-FinalNasalSandhi.pdf": 980,
	"./appendixD2.2.3-VisargaSandhi.pdf": 4587,
	"./appendixF1-PresentSystemVerbalTerminations.pdf": 1820,
	"./appendixF2-PresentSystemVerbalStemClasses.pdf": 1263,
	"./appendixF3-Class3PresentStemDerivation.pdf": 3053,
	"./appendixF4-PerfectVerbalTerminations.pdf": 5360,
	"./appendixF5-AoristStemClasses.pdf": 8212,
	"./appendixG-VerbalIdentification.pdf": 8317,
	"./appendixH-NominalIdentification.pdf": 2520,
	"./appendixH4-CompoundIdentification.pdf": 7765,
	"./appendixH4-CompoundIdentificationHz.pdf": 8959,
	"./appendixJ-CaseMeaning.pdf": 25,
	"./appendixJ8-CaseUseSummary.pdf": 3241,
	"./appendixK1-NominalTerminations.pdf": 8581,
	"./appendixK2.1-deva-Derivation.pdf": 5108,
	"./appendixK2.10-mAtf-Derivation.pdf": 8600,
	"./appendixK2.11-kartf-Derivation.pdf": 2455,
	"./appendixK2.2-Pala-Derivation.pdf": 6941,
	"./appendixK2.3-mAlA-Derivation.pdf": 8037,
	"./appendixK2.4-nadI-Derivation.pdf": 4673,
	"./appendixK2.5-DI-Derivation.pdf": 6841,
	"./appendixK2.6-agni-Derivation.pdf": 9976,
	"./appendixK2.7-vAri-Derivation.pdf": 2292,
	"./appendixK2.8-mati-Derivation.pdf": 8518,
	"./appendixK2.9-DAtf-Derivation.pdf": 8467,
	"./appendixK3.1-rAjan-Derivation.pdf": 8631,
	"./appendixK3.2-nAman-Derivation.pdf": 4607,
	"./appendixK4.1-tad-m-Derivation.pdf": 4031,
	"./appendixK4.2-tad-n-Derivation.pdf": 5807,
	"./appendixK4.3-tad-f-Derivation.pdf": 5012,
	"./appendixK4.4-idam-m-Derivation.pdf": 0,
	"./appendixK4.5-idam-n-Derivation.pdf": 6664,
	"./appendixK4.6-idam-f-Derivation.pdf": 3167,
	"./appendixK4.7-adas-m-Derivation.pdf": 541,
	"./appendixK4.8-adas-n-Derivation-p134.pdf": 972,
	"./appendixK4.8-adas-n-Derivation.pdf": 2491,
	"./appendixK4.9-adas-f-Derivation.pdf": 5862,
	"./appendixL1.1-Class1Paradigms.pdf": 3539,
	"./appendixL1.10-Class10Paradigms.pdf": 5311,
	"./appendixL1.2-Class2Paradigms.pdf": 3353,
	"./appendixL1.3-Class3Paradigms.pdf": 2503,
	"./appendixL1.4-Class4Paradigms.pdf": 545,
	"./appendixL1.5-Class5Paradigms.pdf": 139,
	"./appendixL1.6-Class6Paradigms.pdf": 3553,
	"./appendixL1.7-Class7Paradigms.pdf": 4167,
	"./appendixL1.8-Class8Paradigms.pdf": 649,
	"./appendixL1.9-Class9Paradigms.pdf": 4227,
	"./appendixL2-FutureConditionalAoristoptativeParadigms.pdf": 33,
	"./appendixL3-PerfectParadigms.pdf": 4646,
	"./appendixL4-AoristParadigms.pdf": 880,
	"./appendixM1.1-3-a-stemNominalParadigms.pdf": 2608,
	"./appendixM1.12-14-u-stemNominalParadigms.pdf": 9412,
	"./appendixM1.15-18-f-stemNominalParadigms.pdf": 2558,
	"./appendixM1.4-6-I-stemNominalParadigms.pdf": 7996,
	"./appendixM1.7-8-U-stemNominalParadigms.pdf": 1411,
	"./appendixM1.9-11-i-stemNominalParadigms.pdf": 37,
	"./appendixM2.1-4-n-stemNominalParadigms.pdf": 7369,
	"./appendixM2.15-16.pdf": 7854,
	"./appendixM2.5-18-ConsonantStemParadigms.pdf": 7520,
	"./appendixM3-ActiveParticipleParadigms.pdf": 1111,
	"./appendixM4-PronominalParadigms.pdf": 9024,
	"./appendixM5-NumberParadigms.pdf": 4337,
	"./appendixN1-Preverbs.pdf": 8530,
	"./appendixN1-Pronouns.pdf": 5249,
	"./appendixN3-PronominalAdverbs.pdf": 5339,
	"./appendixN4-ParticipleSummary.pdf": 6057,
	"./appendixO-PrincipalParts.pdf": 4055,
	"./asmad.pdf": 7814,
	"./azwan.pdf": 4869,
	"./balin-m.pdf": 42,
	"./balin-n.pdf": 7221,
	"./cakfvas-m.pdf": 3157,
	"./cakfvas-n.pdf": 570,
	"./catur.pdf": 6725,
	"./dIrGAyus.pdf": 8122,
	"./daDat-m.pdf": 9862,
	"./daDat-n.pdf": 6609,
	"./deva.pdf": 6166,
	"./dvi.pdf": 5395,
	"./eka-f.pdf": 5608,
	"./eka-m.pdf": 1191,
	"./eka-n.pdf": 4032,
	"./enad-f.pdf": 9539,
	"./enad-m.pdf": 4404,
	"./enad-n.pdf": 4987,
	"./fc.pdf": 7269,
	"./figure3.2-DevanagariCharacterGraphs.pdf": 8216,
	"./figure3.3-DependentVowelSigns.pdf": 9847,
	"./havis.pdf": 4301,
	"./hetu.pdf": 1332,
	"./idam-f.pdf": 9772,
	"./idam-m.pdf": 9083,
	"./idam-n.pdf": 1796,
	"./kim-f.pdf": 7264,
	"./kim-m.pdf": 4399,
	"./kim-n.pdf": 1080,
	"./kurvat-m.pdf": 9709,
	"./kurvat-n.pdf": 6818,
	"./mAlA.pdf": 7119,
	"./mAtf.pdf": 956,
	"./maDu.pdf": 7875,
	"./manas.pdf": 6756,
	"./mati.pdf": 5631,
	"./nAman.pdf": 741,
	"./nadI.pdf": 1094,
	"./paYcan.pdf": 7908,
	"./pitf.pdf": 223,
	"./rAjan.pdf": 7522,
	"./sarit.pdf": 6709,
	"./section3.5.5p53-AvagrahaAndEllipsis.pdf": 1100,
	"./section3.5.6p53-WordSeparation.pdf": 2678,
	"./section3.5.7p53-Punctuation.pdf": 9729,
	"./sections4.3.4-5p65-AmbiguousSandhiPragrhya.pdf": 7494,
	"./sraj.pdf": 7602,
	"./strI.pdf": 9878,
	"./suhfd.pdf": 3482,
	"./sumanas.pdf": 7584,
	"./svasf.pdf": 9367,
	"./table13.1-ConsonantStemExampleForms.pdf": 1899,
	"./table16.1-TimeDistanceCaseMeaning.pdf": 8662,
	"./table17.4-PresentActiveParticipleStemFeminineForms.pdf": 3194,
	"./table20.1-CompoundTypes.pdf": 1220,
	"./table3.1-TroublesomePairs.pdf": 6477,
	"./tad-f.pdf": 1442,
	"./tad-m.pdf": 6981,
	"./tad-n.pdf": 5978,
	"./tri.pdf": 5863,
	"./unsegmented.pdf": 4267,
	"./vAri.pdf": 5000,
	"./vaDU.pdf": 9114,
	"./viS.pdf": 7066,
	"./yuzmad.pdf": 7654,
	"./zaz.pdf": 6723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2680;